"use strict";

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @generated SignedSource<<653834c56e388fa35235091eb24cca29>>
 *
 * Generated by CLDRGenScript
 *
 * 
 */
var IntlVariations = require("./IntlVariations");

var IntlCLDRNumberType11 = {
  getVariation: function getVariation(n) {
    if (n % 10 === 1 && n % 100 !== 11) {
      return IntlVariations.NUMBER_ONE;
    } else {
      return IntlVariations.NUMBER_OTHER;
    }
  }
};
module.exports = IntlCLDRNumberType11;